import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accessToken: null,
  refreshToken: null,
  user: null,
  role: null,
  role_id: null,
  pg_id: null, // Add pg_id to initialState
  phoneNumber: null, // Add phoneNumber to initialState
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.user = action.payload.user;
      state.role = action.payload.role;
      state.role_id = action.payload.role_id;
      state.pg_id = action.payload.pg_id; // Add pg_id to setAuthData
      state.phoneNumber = action.payload.phoneNumber; // Add phoneNumber to setAuthData
    },
    clearAuthData: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      state.user = null;
      state.role = null;
      state.role_id = null;
      state.pg_id = null; // Add pg_id to clearAuthData
      state.phoneNumber = null; // Add phoneNumber to clearAuthData
    },
    updateTocAccepted(state) {
      if (state.user) {
        state.user.toc_accepted = true;
      }
    },
    updateUsername: (state, action) => {
      if (state.user) {
        state.user.username = action.payload.username;
      }
    },
    updateEmail: (state, action) => {
      if (state.user) {
        state.user.email = action.payload.email;
      }
    },
  },
});

export const { setAuthData, clearAuthData, updateUsername, updateTocAccepted, updateEmail } = authSlice.actions;

export default authSlice.reducer;